import { combineReducers } from 'redux';
import { campaignMiddleware } from '@domain/partnerships/partners/mobees/new-campaign/campaign/campaign.middleware';
import {
    newCampaignReducer,
    NewCampaignState,
} from '@domain/partnerships/partners/mobees/new-campaign/new-campaign.state';
import { adMiddleware } from '@domain/partnerships/partners/mobees/new-campaign/ads/ad.middleware';
import { campaignTableReducer } from '@domain/partnerships/partners/mobees/campaign-table/campaign-table.state';
import { mobeesFormMiddlewares } from './new-campaign/form/form.middlewares';
import { campaignTableMiddleware } from './campaign-table/campaign-table.middlewares';

export interface MobeesState {
    newCampaign: NewCampaignState;
}

export const mobeesMiddlewares = [
    campaignMiddleware,
    adMiddleware,
    mobeesFormMiddlewares,
    campaignTableMiddleware,
];

export const mobeesReducer = combineReducers({
    newCampaign: newCampaignReducer,
    campaignTable: campaignTableReducer,
});
